import { render } from "./CheckCertificateView.vue?vue&type=template&id=5e2e8e24&scoped=true"
import script from "./CheckCertificateView.vue?vue&type=script&lang=js"
export * from "./CheckCertificateView.vue?vue&type=script&lang=js"

import "./CheckCertificateView.vue?vue&type=style&index=0&id=5e2e8e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2e8e24"]])

export default __exports__